import React, {Component} from 'react';

import {Link,} from 'react-router-dom';
import {connect} from "react-redux";
import {Container, DropdownContainerWrapper, Links, Popup} from "./styles";
import {Url} from "finhelper"

class Header extends Component {
    constructor(props) {
        super(props)

        this.state = {
            open: false
        }
        this.containerRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.containerRef.current && !this.containerRef.current.contains(event.target)) {
            this.setState({open: false});
        }
    }

    toggleDropdown = (e) => {
        e.stopPropagation();
        this.setState(prevState => ({open: !prevState.open}));
    }

    render() {
        let url = Url.getCurrentUrl();

        return (
            <Container
                ref={this.containerRef}
                onMouseEnter={this.toggleDropdown}
                style={{
                    position: 'relative',
                    zIndex: '100',
                    width: '35px',
                    height: '100%'
                }}
            >
                <DropdownContainerWrapper
                    style={{
                        height: (this.state.open) ? '200px' : '100%',
                        position: 'absolute',
                    }}
                >
                    {this.props.children}
                    {this.props.links.length > 0 && (
                        <Popup
                            open={this.state.open}
                            id={this.props.containerId}
                            className={`asset-popup`}
                            top={this.props.top}
                            right={this.props.right}
                            width={this.props.width}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Links>
                                {this.props.links.map((item, key) => {
                                    if (typeof item.onClick === 'function') {
                                        return (
                                            <a key={key} id={item.id} href={item.link}
                                               className={url === item.link ? 'active' : ''} onClick={(e) => {
                                                e.stopPropagation();
                                                item.onClick(e);
                                                this.setState({open: false});
                                            }}>{item.text}</a>
                                        )
                                    }

                                    return <Link onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.setState({open: false});
                                    }} key={key} id={item.id} to={item.link}
                                                 className={url === item.link ? 'active' : ''}>{item.text}</Link>
                                })}
                            </Links>
                        </Popup>
                    )}
                </DropdownContainerWrapper>
            </Container>
        )
    }
}

const enhance = connect(
    (state) => ({}),
    {}
)

export default enhance(Header);
// export default withRouter(enhance(Header));
